//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { intToChinese } from '@/utils';
export default {
  name: 'MoneyFrom',
  props: {
    value: {
      default: undefined,
      type: [Number, String]
    },
    min: {
      default: undefined,
      type: Number
    },
    max: {
      default: undefined,
      type: Number
    },
    precision: {
      default: undefined,
      type: Number
    }
  },
  data: function data() {
    return {
      num: Number(this.value),
      minNum: this.min,
      maxNum: this.max,
      precisionNum: this.precision
    };
  },
  computed: {
    numFrom: function numFrom() {
      return intToChinese(this.num);
    }
  },
  watch: {
    value: function value(n) {
      this.num = Number(n);
    },
    min: function min(n) {
      this.minNum = n;
    },
    max: function max(n) {
      this.maxNum = n;
    },
    precision: function precision(n) {
      this.precisionNum = n;
    },
    num: function num() {
      this.onChange();
    }
  },
  methods: {
    onChange: function onChange() {
      this.$emit('input', this.num);
    }
  }
};